import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Column,Panel,Card} from 'ktm-ui';
import InfoBox from 'components/InfoBox';

interface IdsDateRange {
  Id: string;
  Policy_Id: string;
  Employee_Id: string;
  Dependent_Id: string | null;
  RangeType: string;
  FromDate: string;
  ToDate: string;
  Comment: string;
}

interface State {
  hasAccrual: boolean;
}

export default KTMScreen({ name: "enroll.employee.remove-date-range" },
  class extends React.Component<{dateRange_id:string, employee_id: string, type: string, FromDate: string, ToDate: string, DependentName: string}, any> {

    data: {
      dsDateRange: IdsDateRange;
    };

    state: State = {
      hasAccrual: false,
    };

    render() {
      return renderScreen(this);
    }

    async start({screen}:ActionEvent){
      screen.defaultRecord = "@dsDateRange";

      await KTMApi.start(screen,{
        "@dateRange_id":this.props.dateRange_id,
      });

      try {
        const response = await fetch(`/api/Employees/checkemployeehasaccrual?employeeId=${this.props.employee_id}`);
        const result = await response.json();
        this.setState({ hasAccrual: !!result.hasAccrual });
      } catch (err) {
        console.error("Failed to load HasAccrual status:", err);
      }

      screen.title = "Remove Date Range";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Remove Date Range"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
       return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Remove" style="destructive"/>
            </Dialog.Footer>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        const { RangeType, Dependent_Id } = this.data.dsDateRange;
        const isSelfCoverage = Dependent_Id === null || Dependent_Id === undefined;
        const isInactive = RangeType === "INACTIVE";
        const showSCNote = this.state.hasAccrual && isSelfCoverage && isInactive;

        return (
            <Panel>
                <Column>
                    {showSCNote && (
                    <InfoBox style={{ marginBottom: 20 }} className="remove-date-range-info">    
                        If this date range had resulted in any Inactive Scheduled Credit increments within the employee’s current benefit year,
                        those increment credit amounts will immediately become eligible and be added back into their scheduled total for the year.
                        This is irreversible once done.
                        <br/>
                        Any credits in the previous benefit year or carried into the current year will remain unchanged by removal of this date range.
                    </InfoBox>)}
                    <Card>
                        <div>Are you sure you want to remove this date range?</div>
                    </Card>
                </Column>
            </Panel>
        );
    }

    async submit({screen}:ActionEvent){
        const employeeLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                RangeType: this.data.dsDateRange.RangeType,
                FromDate: this.data.dsDateRange.FromDate,
                ToDate: this.data.dsDateRange.ToDate,
                EmployeeId: this.props.employee_id,
                DependentName: this.props.DependentName,
                Action: "Date Range Removed"
            }),
          };

        await KTMApi.action(screen,"submit",{
            "@dateRange_id":this.props.dateRange_id,
        }).then(async () => {
            await fetch("/api/PlanAdmin/adddaterangelogs", employeeLogs);
        });
        screen.close({"continue":true});
    }
});
